"use client"

import { useEvent } from "@/app/hooks/use-event"
import { Button } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftsToBuyMoleculeReatom } from "./molecule.reatom"

export const CancelNftSelectionButton = reatomComponent(() => {
  const { cancelNftSelection, selectedNftsToBuy } = useMolecule(
    NftsToBuyMoleculeReatom,
  )

  const handleCancel = useEvent(() => {
    console.log("Cancel button clicked, current NFTs:", selectedNftsToBuy())
    cancelNftSelection()
    console.log("After cancel, NFTs:", selectedNftsToBuy())
  })

  return (
    <Button variant="secondary" onClick={handleCancel}>
      Cancel
    </Button>
  )
}, "CancelNftSelectionButton")
